/* eslint-disable no-fallthrough */
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CustomButton from "../../../Component/Button";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUniversityPartners,
  fetchIndustries,
  fetchProgramStudies,
  fetchRegisterSettings,
  fetchAreas,
  fetchObjectives,
  fetchParticularPrograms,
  fetchLanguages,
  fetchExperience,
  registerUser,
  verifyEmail,
  fetchCoursesCompleted,
  fetchBoardExperienceMentor,
  fetchBoardEntityTypeExperience,
  fetchAccreditedDirector,
  fetchBoardExperienceLevel,
  fetchBoardExperience,
} from "./slice/registerSlice";
import { getSettingData } from "../../../actions/settingActions";
import { getAllProgrammes } from "../../../actions/userActions";
import {
  Container,
  Row, Col, Form,
} from "react-bootstrap";
import moment from "moment";
import countryList from "react-select-country-list";
import placeholder from "../../../assets/images/userprofile.png";
import { blobToFile, renderGlobalModal } from "../../../utils/helpers";
import ImageCropper from "../../../Component/ImageCropper";
import SkeletonLoader from "../../UpdateProfile/skeltonLoader";
import queryString from "query-string";
import PopupModalWithOk from "../../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";
import {
  normalizeRegisterPayload,
  buildRegisterFormData,
  applyVerificationDataImmediately,
  applyVerificationDataWithDelay,
  handlePostVerificationEffects,
} from "./registerDataHelpers";
import { renderRegisterField, renderBoardRolesInline } from "./registerFieldRenderers";
import { fetchSettings } from "../../../store/slices/settingsSlice";


const Index = (props) => {
  const dispatch = useDispatch();

  // Component-specific loading state to prevent flash
  const [componentReady, setComponentReady] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  const {
    universityPartners: university_partners_list,
    industries: industry_list,
    programStudies: programStudyId,
    registerStepFields,
    areas,
    objectives: objective,
    particularPrograms: particularProgram,
    languages: languageOptions,
    experienceData: userExperience,
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
  } = useSelector((state) => state.register);

  const { setting } = useSelector((state) => state.settings);
  const { userInfo } = useSelector((state) => state.userInfo);
  const programmes = useSelector((state) => state.programmes);

  let d = new Date();
  d.setMonth(d.getMonth() + 3);
  const nextThreeMonthData = d.toLocaleDateString();
  const location = useLocation();
  const history = useNavigate();

  const {
    title,
  } = props;

  const [dob, setDob] = useState(null);
  const { register, handleSubmit, control, clearErrors, reset, setValue, watch, trigger, formState, formState: { errors }, setError } = useForm();

  const siteName = setting?.name?.trim() || "Register Now as Mentor or Mentee";

  useEffect(() => {
    const title = `${siteName} - Register Now as Mentor or Mentee`;

    document.title = title;

    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        `Register now with ${setting?.name} as a mentor or mentee to join the domain-specific career mentoring between women leaders and experienced industry leaders.`
      );
  }, [siteName, title]);

  const queryStringParsed = queryString.parse(location.search);

  // A valid validating_string must be exactly 32 lowercase hex characters (MD5 hash)
  const isValidValidatingString = (str) =>
    typeof str === "string" && /^[0-9a-f]{32}$/.test(str);

  const [roleId, setRoleId] = useState("");
  const [experience, setExperience] = useState([]);

  const [checkBox, setCheckBox] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [experienceData] = useState([]);
  const [showDateDiv, setShowDateDiv] = useState("none");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(nextThreeMonthData);
  const [emailVerifyString, setEmailVerifyString] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [industryData, setIndustryData] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [getLoader, setGetLoader] = useState(false);
  const [redirectPath, setRedirectPath] = useState(null);

  const customStyles = {
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      top: "32px",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    }),
  };

  const [{ alt, src }, setImg] = useState({
    src: placeholder,
    alt: "Upload an Image",
  });
  const [cropImg, setCropImg] = useState("");
  const [cropImgModalShow, setCropImgModalShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const getUserId = localStorage.getItem("userId");
  const [userId, setUserId] = useState(localStorage.getItem("userId"));
  const options = countryList().getData();
  const [country] = useState(options);
  const [country1, setCountry1] = useState("");
  const [userData] = useState({});
  const [mainArea, setMainArea] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedObjective, setSelectedObjective] = useState([]);
  const [selectedResume, setSelectedResume] = useState("");
  const [resumeText, setResumeText] = useState("");
  const availabilityChecked = watch("availability");

  const countWords = (text) => {
    return text?.replaceAll("\r\n", "\n")?.length;
  };

  useEffect(() => {
    dispatch(fetchSettings());
  }, []);

  const getUniversityPartnerList = async () => {
    dispatch(fetchUniversityPartners());
  };
  const getIndustryList = async () => {
    dispatch(fetchIndustries());
  };

  const getProgramStudyId = async () => {
    dispatch(fetchProgramStudies());
  };

  const registerSetting = async (roleId1) => {
    dispatch(fetchRegisterSettings(roleId1));
  };

  const getAreasData = (page = 1) => {
    dispatch(fetchAreas());
  };

  const getObjectiveData = (roleID) => {
    dispatch(fetchObjectives(roleID));
  };

  const getParticularProgram = async () => {
    dispatch(fetchParticularPrograms());
  };

  useEffect(() => {
    getUniversityPartnerList();
    getIndustryList();
    getParticularProgram();
    getAreasData();
    getProgramStudyId();
  }, [setting]);

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    new Array(currentYear - 1990 + 1),
    (val, index) => 1990 + index
  );

  const checkFromDate = (date) => {
    setFromDate(moment(new Date(date)).format("YYYY-MM-DD"));
  };
  const checkToDate = (date) => {
    setToDate(moment(new Date(date)).format("YYYY-MM-DD"));
  };
  const [email, setEmail] = useState(queryStringParsed.email);

  useEffect(() => {
    if (queryStringParsed.email) setValue("email", queryStringParsed.email);
    dispatch(fetchLanguages());
  }, [queryStringParsed.email]);

  const terminateProcess = registerStepFields?.[0]?.terminate_process;

  // Validate board_roles fields directly from the current step's field definitions
  const validateBoardRoles = (data) => {
    const allFields = registerStepFields?.[0]?.reg_feilds || [];
    const companyNameField = allFields.find(f => f.reg_key === 'rep_company_name');
    const boardTitleField = allFields.find(f => f.reg_key === 'rep_board_title');
    const startDateField = allFields.find(f => f.reg_key === 'rep_start_date');
    const endDateField = allFields.find(f => f.reg_key === 'rep_end_date');

    // If none of the board role fields are in this step, skip
    if (!companyNameField && !boardTitleField && !startDateField && !endDateField) {
      return null;
    }

    const anyRequired =
      companyNameField?.is_required === 1 ||
      boardTitleField?.is_required === 1 ||
      startDateField?.is_required === 1 ||
      endDateField?.is_required === 1;

    if (!anyRequired) return null;

    // board_roles value from RHF - may be array, JSON string, or undefined
    let roles = [];
    const rawValue = data.board_roles;
    if (Array.isArray(rawValue)) {
      roles = rawValue;
    } else if (typeof rawValue === 'string') {
      try { roles = JSON.parse(rawValue); } catch { roles = []; }
    }

    // Must have at least one role entry
    if (roles.length === 0) {
      const msg =
        companyNameField?.validation?.find(v => v.key === 'required')?.message ||
        'At least one board role is required.';
      return msg;
    }

    // Validate each role's individual required fields
    for (let i = 0; i < roles.length; i++) {
      const role = roles[i];

      if (companyNameField?.is_required === 1 && !role.rep_company_name?.trim()) {
        const msg = companyNameField.validation?.find(v => v.key === 'required')?.message || 'Company Name is required.';
        return msg;
      }
      if (boardTitleField?.is_required === 1 && !role.rep_board_title?.trim()) {
        const msg = boardTitleField.validation?.find(v => v.key === 'required')?.message || 'Board Title is required.';
        return msg;
      }
      if (startDateField?.is_required === 1 && !role.rep_start_date?.trim()) {
        const msg = startDateField.validation?.find(v => v.key === 'required')?.message || 'Start Date is required.';
        return msg;
      }
      if (!role.is_currently_working && endDateField?.is_required === 1 && !role.rep_end_date?.trim()) {
        const msg = endDateField.validation?.find(v => v.key === 'required')?.message || 'End Date is required.';
        return msg;
      }
    }

    return null;
  };

  const onSubmit = (data) => {
    // Validate board roles manually since they are managed outside RHF inputs
    const boardRolesError = validateBoardRoles(data);
    if (boardRolesError) {
      setError('board_roles', { type: 'manual', message: boardRolesError });
      return;
    }
    // Store the original password BEFORE any processing
    localStorage.setItem("email", data.email);
    localStorage.setItem("password", data.password);

    const normalizedPayload = normalizeRegisterPayload({
      data,
      roleId,
      dob,
      emailVerifyString,
      selectedResume,
    });

    const formData = buildRegisterFormData({
      data: normalizedPayload,
      registerStepFields,
      selectedFile,
    });

    setGetLoader(true);

    dispatch(
      registerUser({
        params: formData,
        roleId,
        userId,
        terminateProcess,
        step: "step_1",
        paramsLogin: null,
      })
    )
      .unwrap()
      .then((res) => {
        setGetLoader(false);

        if (!res) return;
        // Show popup instead of toaster
        setPopupMessage(res?.message);
        setShowPopup(true);
        // Store redirect path for later
        setRedirectPath(res.redirectTo);
      })
      .catch((error) => {
        setGetLoader(false);
        setPopupMessage(error?.message || "Registration failed");
        setShowPopup(true);
      });
  };



  const handlePopupOk = () => {
    setShowPopup(false);

    if (redirectPath) {
      history(redirectPath);
    }
  };

  const getExperienceData = () => {
    dispatch(fetchExperience());
  };

  const handleChange = (item, action) => {
    getExperienceData();
    setRoleId(item);

    // Fetch board-related data based on role
    if (item === "Mentor" || item === "Mentees") {
      dispatch(fetchCoursesCompleted());
      dispatch(fetchBoardExperience(item));
      dispatch(fetchBoardExperienceLevel(item));
      dispatch(fetchBoardEntityTypeExperience(item));
      dispatch(fetchAccreditedDirector(item));
      dispatch(fetchBoardExperienceMentor("Mentee")); // Always call with "Mentee" for board_entity_type_2
    }
  };
  const handleProgrammesChange = (item, action) => {
    // Program study ID is handled by react-hook-form
    // Clear validation errors when a selection is made
    if (item) {
      clearErrors("program_study_id");
    }
  };

  // 👈 NO dispatch dependency

  useEffect(() => {
    dispatch(fetchRegisterSettings({
      step_key: "step_1"
    }));
  }, []);


  const initSettings = async () => {
    try {
      dispatch(getSettingData());

      const keysToRemove = ["redirectFrom", "email_verify", "temp_step"];
      for (const key of keysToRemove) {
        localStorage.removeItem(key);
      }

      dispatch(getAllProgrammes());

      if (queryStringParsed.validating_string) {
        if (!isValidValidatingString(queryStringParsed.validating_string)) {
          history("/not-found");
          return;
        }
        if (userInfo?.id) {
          history(`/manage-profile`);
        } else {
          dispatch(verifyEmail(queryStringParsed.validating_string))
            .unwrap()
            .then((res) => {
              const data = res?.data;
              applyVerificationDataImmediately({
                data,
                setValue,
                setRoleId,
                handleChange,
                setEmail,
              });

              setTimeout(() => {
                applyVerificationDataWithDelay({
                  data,
                  reset,
                  setValue,
                  clearErrors,
                  setSelectedFile,
                  setImg,
                  setResumeText,
                  setSelectedResume,
                  setShowDateDiv,
                  checkFromDate,
                  checkToDate,
                  setDob,
                  placeholderImage: placeholder,
                });
              }, 1000);


              handlePostVerificationEffects({
                data,
                res,
                setting,
                setReadOnly,
                setEmailVerifyString,
                getObjectiveData,
                registerSetting,
                setUserId,
                setPopupMessage,
                setShowPopup,
                history,
                renderGlobalModal,
              });
            })
            .catch((err) => {

              renderGlobalModal({ message: err.message })
            });
        }
      }

      // Admin approval flag is checked directly from setting

      // Add a small delay to ensure SkeletonLoader shows briefly
      setTimeout(() => {
        // Mark component as ready and data as loaded
        setComponentReady(true);
        setInitialDataLoaded(true);
      }, 300); // 300ms delay
    } catch (err) {
      console.error("Error in initSettings:", err);
      // Don't set loading states to true on error - let user see the error state
    }
  };

  useEffect(() => {
    initSettings();
  }, []);

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  useEffect(() => {
    document.title = title;
    getAreasData();
  }, [title, getUserId, setting]);

  const onChangePicture = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      setImg({ src: placeholder, alt: "Upload an Image" });
      setGetLoader(true);
      return;
    }

    const allowedExtensions = ["jpg", "jpeg", "png"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      setPopupMessage("Please select valid image format (jpg, jpeg, png)");
      setShowPopup(true);
      return;
    }

    // ✅ 30 MB check (STANDARDIZED)
    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > 30) {
      setPopupMessage("Please select image size less than 30 MB");
      setShowPopup(true);
      setImg({ src: placeholder, alt: "Upload an Image" });
      return;
    }

    clearErrors("image");

    setImg({
      src: placeholder,
      alt: file.name,
    });

    setCropImg(URL.createObjectURL(file));
    setCropImgModalShow(true);
    setGetLoader(false);
  };

  const onChangeResume = (e) => {
    if (e.target.files[0]) {
      const selectedResume = e.target.files[0];
      setSelectedResume(selectedResume);
      setResumeText(selectedResume.name);
      // Clear any validation errors for this field
      clearErrors('resume');
    }
  };


  const fileToImage = (childdata) => {
    setSelectedFile(blobToFile(childdata, getUserId + ".png"));
    setImg({
      src: URL.createObjectURL(childdata),
      alt: "",
    });
    setCropImgModalShow(false);
  };


  useEffect(() => {
    if (selectedObjective.length > 0) {
      setValue("objective", selectedObjective);
      clearErrors("objective");
      trigger("objective");
    }
  }, [selectedObjective, setValue, clearErrors, trigger]);

  useEffect(() => {
    if (experienceData?.length > 0) {
      setExperience(experienceData.map((item) => item.id));
    }
  }, [experienceData]);

  const renderField = (field) =>
    renderRegisterField(field, {
      control,
      register,
      errors,
      watch,
      setValue,
      clearErrors,
      trigger,
      email,
      setEmail,
      readOnly,
      showPassword,
      togglePasswordVisibility,
      emailVerifyString,
      roleId,
      handleChange,
      handleProgrammesChange,
      programmes,
      programStudyId,
      university_partners_list,
      years,
      userExperience,
      country,
      country1,
      setCountry1,
      userData,
      languageOptions,
      customStyles,
      industry_list,
      industryData,
      setIndustryData,
      particularProgram,
      checkBox,
      setCheckBox,
      checkBox2,
      setCheckBox2,
      availabilityChecked,
      showDateDiv,
      checkFromDate,
      checkToDate,
      fromDate,
      toDate,
      setShowDateDiv,
      onChangePicture,
      selectedFile,
      src,
      alt,
      resumeText,
      onChangeResume,
      mainArea,
      setMainArea,
      selectedArea,
      setSelectedArea,
      areas,
      selectedObjective,
      setSelectedObjective,
      objective,
      experience,
      setExperience,
      dob,
      setDob,
      countWords,
      // Board-related data
      coursesCompleted,
      boardExperienceMentor,
      boardEntityTypeExperience,
      accreditedDirector,
      boardExperienceLevel,
      boardExperience,
      // Settings for board_roles_validation
      setting,
    });


  return (
    isValidValidatingString(queryStringParsed?.validating_string) ? <>
      {/* SkeletonLoader - show while component is not ready or data is not loaded */}
      {(!componentReady || !initialDataLoaded) && <SkeletonLoader />}

      {/* Main content - show only when component is ready and data is loaded */}
      <div style={{ display: (componentReady && initialDataLoaded) ? 'block' : 'none' }}>
        <section className="loginouter">
          <Container>
            <Row className="align-items-center ">
              <Col md={12}>
                <div className="logininnerouter resetouter">
                  <div>
                    <div className="loginlogo text-center mb-5">
                      <Link to="/" className="logo m-0">
                        <img
                          src={setting?.logo_path}
                          alt={setting?.name}
                        // style={{ maxWidth: "200px", maxHeight: "59px" }}
                        />
                      </Link>
                    </div>
                    {registerStepFields?.map((resp, index) => {
                      return (
                        <div className="loginform" key={resp?.id || index}>
                          <h1>{resp?.step_label}</h1>
                          <Form onSubmit={handleSubmit(onSubmit)} className="sadsadsadsad">
                            <Row>
                              {(() => {
                                // Track which board role fields have been rendered
                                let renderedBoardRoleFields = new Set();

                                return (
                                  <>
                                    {resp?.reg_feilds?.map((field, idx) => {
                                      const boardRoleFieldKeys = ['rep_company_name', 'rep_board_title', 'rep_start_date', 'rep_end_date'];
                                      const isBoardRoleField = boardRoleFieldKeys.includes(field.reg_key);

                                      // Skip if already rendered as part of a group
                                      if (renderedBoardRoleFields.has(field.reg_key)) {
                                        return null;
                                      }

                                      // If this is the first board role field, render the entire group
                                      if (isBoardRoleField && field.reg_key === 'rep_company_name') {
                                        renderedBoardRoleFields.add('rep_company_name');
                                        renderedBoardRoleFields.add('rep_board_title');
                                        renderedBoardRoleFields.add('rep_start_date');
                                        renderedBoardRoleFields.add('rep_end_date');

                                        return (
                                          <React.Fragment key="board_roles_group">
                                            {renderBoardRolesInline(resp?.reg_feilds, {
                                              control,
                                              register,
                                              errors,
                                              watch,
                                              setValue,
                                              clearErrors,
                                              trigger,
                                              roleId,
                                              setting,
                                              formState,
                                              setError,
                                            })}
                                          </React.Fragment>
                                        );
                                      }

                                      // Skip other board role fields (they're rendered as a group)
                                      if (isBoardRoleField) {
                                        return null;
                                      }

                                      // Render normal fields
                                      return (
                                        <React.Fragment key={field.reg_key}>
                                          {renderField(field)}
                                        </React.Fragment>
                                      );
                                    })}

                                    {/* Submit button */}
                                    <Col md={12}>
                                      <div className="form-group my-3">
                                        <CustomButton
                                          title={
                                            terminateProcess == "Yes"
                                              ? "Submit"
                                              : "Save & Next"
                                          }
                                          disabled={getLoader}
                                          className={"btn w-100 loginsubmit"}
                                        >
                                          {getLoader ? "Submitting..." : "Submit"}
                                        </CustomButton>
                                      </div>
                                    </Col>

                                    {/* Login link */}
                                    <Col md={12} className="text-center">
                                      <Form.Group>
                                        Already have an account?&nbsp;
                                        <Link to="/login" className="text-danger">
                                          Login
                                        </Link>
                                      </Form.Group>
                                    </Col>
                                  </>
                                );
                              })()}
                            </Row>
                          </Form>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {cropImgModalShow && (
          <ImageCropper
            show={true}
            cropImg={cropImg}
            fileToImage={fileToImage}
            onHide={() => {
              setCropImgModalShow(false);
            }}
            centered={true}
            size="xl"
            className="cropper-modal"
            style={{ zIndex: 9999 }}
          />
        )}

        <PopupModalWithOk
          show={showPopup}
          onHide={() => setShowPopup(false)}
          message={popupMessage}
          showConfirm={true}
          staticBackdrop={true}
          onConfirm={handlePopupOk}
        />
      </div>
    </> : ""

  );
};

Index.propTypes = {
  title: PropTypes.string,
};


export default Index;
